var t=Object.prototype;var o=function(o){var r=o&&o.constructor;return o===("function"==typeof r&&r.prototype||t)};export{o as default};
//# sourceMappingURL=_isPrototype.js.map
